// extracted by mini-css-extract-plugin
export var button = "_redotech-redo-i18n-lib-locale-selector-button";
export var container = "_redotech-redo-i18n-lib-locale-selector-container";
export var icon = "_redotech-redo-i18n-lib-locale-selector-icon";
export var select = "_redotech-redo-i18n-lib-locale-selector-select";